import { useLocation } from 'react-router-dom';

const redirectUrlKey = 'redirect-url';

type UseRedirectAfterLoginReturn = {
  setUrl: () => void;
  getUrl: () => string | null;
  clearUrl: () => void;
};

const useRedirectAfterLogin = (): UseRedirectAfterLoginReturn => {
  const location = useLocation();

  const getUrl = (): string | null => localStorage.getItem(redirectUrlKey);
  const clearUrl = (): void => localStorage.removeItem(redirectUrlKey);

  const setUrl = (url?: string) => {
    const currentPath: string = location.pathname
      ? `${location.pathname}${location.search}`
      : '';

    localStorage.setItem(redirectUrlKey, url ?? currentPath);
  };

  return { setUrl, getUrl, clearUrl };
};

export default useRedirectAfterLogin;
